import React from "react";
import { Row, Col, Form, Input } from "antd";
import {
  SectionHeading,
  DataHeading,
  GhostButtonComponent,
  SliderMainHeader
} from "../../../../CommonComponents/commonStyles";
import { ContactUs  } from "../../styles";
import { UserIdForm, HitASnag, Snag , SuccessImg} from "./styles";
import { HorizontalDivider } from "../../styles";
import tick from "../../../../assets/icons/small-circle-tick.svg";
import {
  ContentProvider,
  ContentMessage,
  Types
} from "../../../../CommonComponents/ContentMessages";
import PropTypes from 'prop-types';
import { GeneralButton } from "../../../../CommonComponents/Commons/commonComponents";

export default function UpdateIDSuccess(props) {
  return (
    <div data-test="userIdSuccess">
      <ContentProvider types={[Types.GET_CONFIRMATION_MESSAGE]} pages={["User ID Updated"]}>
        <SectionHeading>
          <SliderMainHeader>
            <ContentMessage type={[Types.GET_CONFIRMATION_MESSAGE]} page="User ID Updated" property="field_page_title" defaultMessage="User ID Updated" />
          </SliderMainHeader>  
        </SectionHeading>   
        <Row>
          <Col lg={16} md={13}>
            <UserIdForm>
                <SuccessImg src={tick} alt="tick"/>
              <DataHeading className="mb-50">
              <ContentMessage type={[Types.GET_CONFIRMATION_MESSAGE]} html={true} page="User ID Updated" property="field_success_message" defaultMessage="<p>You have successfully changed your user ID.</p>" />
              </DataHeading>
              <GeneralButton
                text="DONE"
                type="functional"
                disabled={false}
                id="btnDone"
                width="150px"
                maxWidth="990px"
                mobWidth="100%"
                onClick={props.closeDrawer}
                inverted={true}
              />
            </UserIdForm>
          </Col>
        </Row>
      </ContentProvider>
      <div className="mt-50">
      <HorizontalDivider />
      </div>
      <HitASnag className="mt-50" style={Snag}>                                
          <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} page="My Profile" property="field_type_8_title" defaultMessage="Hit a Snag?" />
      </HitASnag>
      <ContactUs>
        <ContentMessage type={[Types.SUB_HEADING_LEGACY_OPTIONS]} html={true} page="My Profile" property="field_type_8_description" defaultMessage="<p>Contact us: <br><span class='updateUserIdSnagContent'>888-383-4483 </span>or <br> <span class='updateUserIdSnagContent'>https://www.vanguardcharitable.org/contact-us</span></p>" />
      </ContactUs>
    </div>
  );
}

UpdateIDSuccess.propTypes = {
  userid: PropTypes.string.isRequired,
  newUserId: PropTypes.string.isRequired,
  closeDrawer: PropTypes.func.isRequired
}